module.exports = __webpack_public_path__ + "media/assets/images/tour/class_post-1aa21b6d79a56f6e46fa56cdfb83b3df.jpg";